import * as React from 'react';

/**
 * TabPanel component that renders the content associated with a tab
 */

export interface TabPanelProps {
  ariaLabelledBy: string;
  containerStyle: React.CSSProperties;
  content: React.ReactNode;
  id: string;
}

export function TabPanel(props: TabPanelProps): JSX.Element {
  const containerProps = {
    'aria-labelledby': props.ariaLabelledBy,
    id: props.id,
    role: 'tabpanel',
    style: props.containerStyle
  };

  return (
    <div {...containerProps}>
      {props.content}
    </div>
  );
}
